module.exports = __webpack_public_path__ + "media/bootstrap-icons/arrow-left-short-c795432e.svg";